import { render, staticRenderFns } from "./VxSlideButton.vue?vue&type=template&id=0ef406ae&scoped=true"
import script from "./VxSlideButton.vue?vue&type=script&lang=js"
export * from "./VxSlideButton.vue?vue&type=script&lang=js"
import style0 from "./VxSlideButton.vue?vue&type=style&index=0&id=0ef406ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef406ae",
  null
  
)

export default component.exports